namespace Matrix.Exceptions {
    export interface ExceptionInboxIgnoringForm {
        EntityId: Serenity.IntegerEditor;
        IgnoredUntil: Serenity.DateTimeEditor;
    }

    export class ExceptionInboxIgnoringForm extends Serenity.PrefixedContext {
        static formKey = 'Exceptions.ExceptionInboxIgnoring';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ExceptionInboxIgnoringForm.init)  {
                ExceptionInboxIgnoringForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.DateTimeEditor;

                Q.initFormType(ExceptionInboxIgnoringForm, [
                    'EntityId', w0,
                    'IgnoredUntil', w1
                ]);
            }
        }
    }
}
